import { QUERY_KEYS } from '@/shared/api';
import { queryOptions } from '@tanstack/react-query';
import { getMeta } from './v1';

export const metaQueries = {
  get: () =>
    queryOptions({
      queryKey: [QUERY_KEYS.GET_META],
      queryFn: getMeta,
    }),
};
